
import { Vue, Component, Prop } from "vue-property-decorator"
import api from "../honcierge-api"
import VueCropper from "vue-cropperjs"
import "cropperjs/dist/cropper.css"

@Component({
  components: { VueCropper },
})
export default class EyecatchCrop extends Vue {
  @Prop({ default: NaN })
  private aspectRatio!: number
  @Prop()
  private type!: string
  @Prop()
  private maxWidth!: number
  @Prop()
  private initQuality!: number

  private quality = 1
  private dialog = false
  private imgSrc = "" // dataURL
  private filename = ""

  private init() {
    this.quality = this.initQuality
    this.dialog = false
    this.imgSrc = ""
    this.filename = ""
    this.initInput()
  }

  private initInput() {
    // https://stackoverflow.com/questions/20549241/how-to-reset-input-type-file/31751943
    const input = this.$refs.input as InstanceType<typeof HTMLInputElement>
    input.type = ""
    input.type = "file"
  }

  /**
   *  最終的に加工済みの画像をダイレクトアップロードをする
   *  そのあとにvuex側のeyecatchの値も更新する
   */
  private async ok() {
    const store = this.$store
    const cropper = this.$refs.cropper as InstanceType<typeof VueCropper>
    const blob: Blob = await new Promise((resolve) =>
      cropper
        .getCroppedCanvas({ maxWidth: this.maxWidth })
        .toBlob(resolve, "image/jpeg", this.quality)
    )

    const fileReader = new FileReader()

    fileReader.onload = async () => {
      const uploadedResponse = await api
        .createDirectUpload(
          new File([blob], this.filename, { type: blob.type })
        )
        .catch(() => {
          this.$toasted.error("エラーが発生しました")
          console.log("direct upload error")
          this.init()
          return
        })
      if (uploadedResponse instanceof Error || !uploadedResponse) {
        throw uploadedResponse
      }

      const imageResponse = await api
        .getImageUrl(uploadedResponse.id)
        .catch(() => {
          this.$toasted.error("エラーが発生しました")
          console.log("get image url error")
          this.init()
          return
        })
      let updateObject: { [key: string]: { filename: string; url: string } } =
        {}
      if (imageResponse) {
        updateObject[this.type] = {
          filename: this.filename,
          url: imageResponse.data.url,
        }
      }
      store.dispatch("article/updateArticle", updateObject)

      this.init()
    }
    fileReader.readAsDataURL(blob)
  }

  private reset() {
    const cropper = this.$refs.cropper as InstanceType<typeof VueCropper>
    cropper.reset()
  }

  private showFileChooser() {
    this.initInput() // 同じファイルを選択し直せるようにするために初期化する
    const input = this.$refs.input as InstanceType<typeof HTMLInputElement>
    input.click()
  }

  /**
   * vue-cropperjsのコンポーネントにリサイズ済みのdataURLを設定する
   * リサイズ処理自体はresizeImageメソッドで行われる
   */
  private setImage(e: Event) {
    const target = e.target as HTMLInputElement
    const file = (target.files as FileList)[0]
    if (file.type.indexOf("image/") === -1) {
      this.$toasted.error("画像ファイルを指定して下さい")
      return
    }
    this.filename = file.name
    if (typeof FileReader === "function") {
      const reader = new FileReader()
      reader.onload = (event) => {
        const image = new Image()

        image.onload = () => {
          // image.srcにおけるload完了時
          this.imgSrc = this.resizeImage(image)

          // rebuild cropperjs with the updated source
          const cropper = this.$refs.cropper as InstanceType<typeof VueCropper>
          if (cropper) {
            cropper.replace(this.imgSrc)
          }
        }
        const t = event.target as FileReader
        image.src = t.result as string
      }
      reader.readAsDataURL(file)
    } else {
      this.$toasted.error("エラーが発生しました")
      return
    }
  }

  /**
   * originalImage[string] dataURL
   * return リサイズされた画像のdataURL
   */
  private resizeImage(originalImage: HTMLImageElement): string {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")

    canvas.width = originalImage.width
    canvas.height = originalImage.height

    let ratio = 1
    if (originalImage.width >= this.maxWidth) {
      ratio = this.maxWidth / originalImage.width // ratio <= 1
      canvas.width = this.maxWidth
      canvas.height = originalImage.height * ratio
    } else {
      // originalImage.width < this.maxWidth
      ratio = this.maxWidth / originalImage.width // ratio > 1
      canvas.width = originalImage.width
      canvas.height = originalImage.height
    }
    if (ctx) {
      ctx.drawImage(originalImage, 0, 0, canvas.width, canvas.height)
    }
    return canvas.toDataURL()
  }
}
